import { motion } from "framer-motion";

export default function Stamp({ text = "K NUTRITION · SALERNO · ", className = "", dark = false }) {
  return (
    <div className={`pointer-events-none ${className}`} aria-hidden="true" data-testid="stamp-badge">
      <motion.svg
        viewBox="0 0 120 120"
        className="w-full h-full"
        animate={{ rotate: 360 }}
        transition={{ duration: 26, repeat: Infinity, ease: "linear" }}
      >
        <defs>
          <path id="stamp-circle" d="M 60,60 m -45,0 a 45,45 0 1,1 90,0 a 45,45 0 1,1 -90,0" />
        </defs>
        <circle cx="60" cy="60" r="59" className={dark ? "fill-charcoal/60" : "fill-ivory/90"} />
        <text
          className={dark ? "fill-sand" : "fill-deeptaupe"}
          style={{ fontSize: "8.6px", letterSpacing: "0.9px", fontFamily: "Outfit, sans-serif" }}
        >
          <textPath href="#stamp-circle">{`${text}${text}`}</textPath>
        </text>
        <circle cx="60" cy="60" r="4.5" className={dark ? "fill-sand" : "fill-taupe"} />
      </motion.svg>
    </div>
  );
}
